<template>
  <div class="reward-box" v-if="show" @click.self="closed">
    <div class="reward-container">
      <img
        class="icon icon1 wow"
        :class="{ slideInDown: show }"
        src="@/assets/salary/reward/icon1.png"
        alt=""
      />
      <img
        class="icon icon2 wow slideInRight"
        src="@/assets/salary/reward/icon2.png"
        alt=""
      />
      <img
        class="icon icon3 wow slideInLeft"
        src="@/assets/salary/reward/icon3.png"
        alt=""
      />
      <img class="icon icon5" src="@/assets/salary/reward/icon5.png" alt="" />

      <div class="content">
        <div class="content-main">
          <p class="title">{{ bonus.year | formatDate }}<span>年</span></p>
          <div class="line"></div>
          <div class="name">
            亲爱的<span>{{ salaryInfo.title }}</span>
          </div>
          <div class="desc">
            <p>感谢您过去一年的辛勤工作，鉴于您的</p>
            <p>工作表现，结合公司经营业绩、</p>
            <p>所在部门和个人绩效，</p>
            <p>我们将为您发放年度激励</p>
            <p>以资鼓励！激励金额如下</p>
          </div>
          <div class="line2"></div>
          <div class="s-title">激励实发合计</div>
          <p class="money">{{ bonus.real_total }}</p>
          <div class="tip">
            <p class="mb-1">
              <span>“光随心行，智亮未来”，未来的日子，任重道远，</span>
            </p>
            <p><span>愿我们不负当下，不惧未来，再创佳绩！</span></p>
          </div>
          <div class="btn" @click="toReward"></div>
        </div>

        <img
          class="icon close"
          @click="closed"
          src="@/assets/salary/close.png"
          alt=""
        />
        <img class="icon icon4" src="@/assets/salary/reward/icon4.png" alt="" />
        <img class="icon under" src="@/assets/salary/reward/under.png" alt="" />
        <img class="icon up" src="@/assets/salary/reward/up.png" alt="" />
        <img class="icon logo" src="@/assets/salary/reward/logo.png" alt="" />
        <img
          class="content_bg"
          src="@/assets/salary/reward/content_bg.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import utils from "@/assets/js/utils.js";
export default {
  data() {
    return {
      salaryInfo: {},
    };
  },
  created() {
    this.salaryInfo = JSON.parse(localStorage.getItem("salaryInfo"));
    console.log(this.salaryInfo);
  },
  mounted() {
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
      reality: 0,
    });
    wow.init();
    console.log(this.bonus,'bonusbonus');
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    bonus: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  filters: {
    formatDate(val) {
      return utils.formatDate(new Date(val).getTime() / 1000, "yyyy");
    },
  },
  methods: {
    accumulativeMachine() {
      setTimeout(() => {
        this.formatSpeed = Math.floor(Math.random() * (200 - 100)) + 100;
        this.reality += this.formatSpeed;
        if (this.reality >= this.bonus.real_total) {
          this.reality = this.bonus.real_total;
          return;
        }
        this.accumulativeMachine();
      }, 20);
    },
    closed() {
      this.$emit("closed");
    },
    toReward() {
      this.$router.push({ path: "/reward" });
    },
  },
};
</script>

<style lang='scss' scoped>
@keyframes easing {
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.9);
  }
}
@keyframes fadeInDown {
  0% {
    top: -200px;
    opacity: 0.2;
  }
  100% {
    top: -53px;
    opacity: 1;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.reward-box {
  width: 100%;
  height: 100vh;
  background: rgba($color: #000000, $alpha: 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  overflow: hidden;
  animation: fadeIn 0.8s linear;
}
.reward-container {
  position: relative;
  width: 750px;
  height: 100%;
  overflow: hidden;
  margin: 0 auto;

  & > .icon {
    position: absolute;
  }
  & > .icon1 {
    width: 150px;
    top: -53px;
    right: 86px;
    animation: easing 2s infinite linear;
  }
  & > .icon2 {
    width: 120px;
    right: 0;
    top: 50%;
    z-index: 11;
    animation: easing 4s infinite linear;
  }
  & > .icon3 {
    width: 150px;
    left: -40px;
    bottom: 4%;
    animation: easing 4s infinite linear;
  }

  & > .icon5 {
    width: 360px;
    right: -60px;
    bottom: -60px;
  }

  .content {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
    text-align: center;
    font-size: 0;
    .content-main {
      position: relative;
      z-index: 10;
    }

    .title {
      padding-top: 40px;
      font-size: 80px;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #c9393e;
      & > span {
        font-size: 30px;
      }
    }
    .line {
      margin: 10px auto 40px;
      width: 390px;
      height: 1px;
      background: #c9393e;
      position: relative;
      &::after {
        content: "";
        display: block;
        width: 5px;
        height: 5px;
        background: #c9393e;
        border-radius: 50%;
        position: absolute;
        top: -2px;
        right: 0;
      }
      &::before {
        content: "";
        display: block;
        width: 5px;
        height: 5px;
        background: #c9393e;
        border-radius: 50%;
        position: absolute;
        top: -2px;
        left: 0;
      }
    }
    .line2 {
      margin: 40px auto;
      width: 390px;
      height: 1px;
      background: #565656;
      opacity: 0.56;
    }
    .name {
      margin-bottom: 30px;
      font-size: 28px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #555555;
      & > span {
        padding: 2px 20px;
        font-size: 32px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #c9393e;
        border-bottom: 1px solid #504a3e;
      }
    }
    .desc {
      & > p {
        font-size: 26px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #565656;
        line-height: 48px;
      }
    }
    .s-title {
      font-size: 28px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      color: #565656;
    }
    .money {
      font-size: 40px;
      font-family: HarmonyOS Sans SC;
      font-weight: bold;
      color: #c9393e;
      margin: 30px auto 40px;
    }
    .tip {
      & > p {
        text-align: center;
        font-size: 18px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #565656;
        & > span {
          display: inline-block;
          line-height: 40px;
          border-bottom: 1px solid rgba($color: #7d7769, $alpha: 0.43);
        }
      }
    }
    .btn {
      margin: 40px auto 0;
      width: 403px;
      height: 107px;
      background: url("~@/assets/salary/reward/btn.png") no-repeat;
      background-size: contain;
      animation: easing 3s infinite linear;
    }
    .close {
      position: absolute;
      bottom: -12%;
      left: 50%;
      transform: translateX(-50%);
      width: 40px;
      cursor: pointer;
      z-index: 11;
    }
    .content_bg {
      width: 700px;
      position: absolute;
      z-index: 9;
      top: 50%;
      left: 10px;
      transform: translateY(-50%);
    }
    .icon4 {
      position: absolute;
      width: 100px;
      left: 360px;
      top: -13%;
      z-index: 11;
    }
    & > .under {
      position: absolute;

      width: 574px;
      top: -33.6%;
      left: -6.6%;
      z-index: 8;
    }
    & > .up {
      position: absolute;
      width: 530px;
      top: -34%;
      left: -15.6%;
      z-index: 12;
    }
    & > .logo {
      position: absolute;
      width: 132px;
      top: -12%;
      left: 18%;
      z-index: 12;
    }
  }
}
</style>